var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.77212 7.86574C3.28495 8.24465 3 8.82726 3 9.44445V19.4663C3 19.9967 3.21071 20.5054 3.58579 20.8805C3.96086 21.2556 4.46957 21.4663 5 21.4663L9 21.4663V13.4663C9 12.914 9.44772 12.4663 10 12.4663H14C14.5523 12.4663 15 12.914 15 13.4663V21.4663L19 21.4663C19.5304 21.4663 20.0391 21.2556 20.4142 20.8805C20.7893 20.5054 21 19.9967 21 19.4663V9.44444C21 8.82726 20.7151 8.24465 20.2279 7.86574L13.2279 2.4213C12.5057 1.85957 11.4943 1.85957 10.7721 2.4213L3.77212 7.86574Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.82262003aa89c0c514cb55c285df3443.svg";
export { ForwardRef as ReactComponent };